export const CheckIcon = ({
  fill = 'currentColor',
  width = '13',
  height = '9',
  viewBox = '0 0 13 9',
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M11.4665 0.799805L4.13314 8.13314L0.799805 4.7998"
      stroke={fill}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
